import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { SupportApiResponse } from '@twiliointernal/org/twilio/e2-commons/shared/definitions';

import { types } from './definitions';
import { SupportApi } from '../../clients';

const useWiseOwlSubmitFeedback = ({
  isLoggedIn,
}: {
  isLoggedIn: boolean;
}): UseMutationResult<
  SupportApiResponse<{}>,
  any,
  types.UseWiseOwlSubmitFeedbackArgs
> => {
  return useMutation({
    mutationFn: (args: types.UseWiseOwlSubmitFeedbackArgs) => {
      const { chatId, messageId, positive, feedback } = args;

      if (!isLoggedIn) {
        return SupportApi.ungatedCreateWiseOwlFeedback(
          chatId,
          messageId,
          feedback,
          positive,
        );
      }

      return SupportApi.createWiseOwlFeedback(
        chatId,
        messageId,
        feedback,
        positive,
      );
    },
  });
};

export default useWiseOwlSubmitFeedback;
